import { render, staticRenderFns } from "./TotalCalls.vue?vue&type=template&id=e26c52ce&scoped=true"
import script from "./TotalCalls.vue?vue&type=script&lang=js"
export * from "./TotalCalls.vue?vue&type=script&lang=js"
import style0 from "./TotalCalls.vue?vue&type=style&index=0&id=e26c52ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e26c52ce",
  null
  
)

export default component.exports